import { withStore } from '../../decorators/withStore';
import { appBannerStore } from '../../store/appBannerStore';
import React, { Component, PureComponent } from 'react';
import { IFrame } from '../../component/IFrame/IFrame';

@withStore
export class AppBanner extends PureComponent {

  static getStores() {
    return [appBannerStore];
  }

  static calculateState() {
    return {
      content: appBannerStore.content
    };
  }

  /** @type {IFrame} */
  iframe;

  componentDidMount() {
    if (this.state.content) {
      this.renderContentIntoIframe();
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.content && this.state.content !== prevState.content) {
      this.renderContentIntoIframe();
    }
  }

  render() {
    const { content } = this.state;
    return (
      <div
        display-if={content}
        className="esk-app-banner"
      >
        <IFrame ref={this._setIframeRef} />
      </div>
    );
  }

  renderContentIntoIframe = () => {
    if (!this.iframe) {
      return;
    }

    this.iframe.iFrame.contentWindow.document.open();
    this.iframe.iFrame.contentWindow.document.write(this.state.content);
    this.iframe.iFrame.contentWindow.document.close();
    this.iframe.iFrame.contentWindow.document.body.style.margin = '0px';
    this.iframe.resetHeight();
    this.iframe._toContentHeight();
  }

  _setIframeRef = (iframe) => {
    this.iframe = iframe;
  }

}
